
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取音乐列表集合
    GetMusicInfoMusicInfoSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MusicInfo/MusicInfoSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 添加音乐
    MusicInfoMusicInfoAddVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MusicInfo/MusicInfoAddVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 删除音乐
    MusicInfoMusicInfoDelVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/MusicInfo/MusicInfoDelVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
